module.exports = __webpack_public_path__ + "img/plan.9d5e71d0.jpeg";